import React from "react";

const ProperSpinner = () => {
  return (
    <div className="proper--spinner--container">
      <div className="proper--spinner"></div>
    </div>
  );
};

export default ProperSpinner;
